import { render, staticRenderFns } from "./associationPackage.vue?vue&type=template&id=c4b56f68&scoped=true&"
import script from "./associationPackage.vue?vue&type=script&lang=js&"
export * from "./associationPackage.vue?vue&type=script&lang=js&"
import style0 from "./associationPackage.vue?vue&type=style&index=0&id=c4b56f68&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4b56f68",
  null
  
)

export default component.exports